import { SEOHead } from "@/components/SEOHead";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import {
  HeroSection,
  PhotoGallerySection,
  ProblemSection,
  ImageBreakSection,
  HowTheDayFlowsSection,
  DifferentiatorsSection,
  TestimonialsSection,
  ExperienceOptionsSection,
  ComparisonSection,
  LocationMapSection,
  FinalCTASection,
} from "@/components/home/HomeSections";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Son's Guadalupe | Private River Cabanas & Tubing in New Braunfels, TX"
        description="Private riverside cabanas, family-friendly tubing & glamping on the Guadalupe River in New Braunfels. Float back to your own cabana — not a parking lot. Only 21 cabanas available. Book today!"
        canonical="/"
        schemaJson={{
          "@context": "https://schema.org",
          "@type": "TouristAttraction",
          name: "Son's Guadalupe",
          description: "Private riverside cabanas, tubing, and glamping on the Guadalupe River in New Braunfels, TX.",
          url: "https://sonsguadalupe.com",
          telephone: "877-577-7667",
          address: {
            "@type": "PostalAddress",
            streetAddress: "7308 River Road",
            addressLocality: "New Braunfels",
            addressRegion: "TX",
            postalCode: "78132",
            addressCountry: "US",
          },
        }}
      />
      <Header />
      <main>
        <HeroSection />
        <PhotoGallerySection />
        <ExperienceOptionsSection />
        <ProblemSection />
        <ImageBreakSection />
        <HowTheDayFlowsSection />
        <DifferentiatorsSection />
        <TestimonialsSection />
        <ComparisonSection />
        <LocationMapSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
